module.exports = __webpack_public_path__ + "img/18ne.f00bf365.svg";